module.exports = __webpack_public_path__ + "img/media-folder-plus.fedd3d4d.svg";